$(document).on('click', '[data-prototype-append]', function (e) {
    e.preventDefault();

    var $add = $(this),
        $prototypeWrapper = $($add.attr('data-prototype-append')),
        count = parseInt($prototypeWrapper.attr('data-prototype-count')) + 1 || $prototypeWrapper.children().length;

    $prototypeWrapper.attr('data-prototype-count', count);

    var name = $prototypeWrapper.attr('data-prototype-name') || '__name__',
        proto = $prototypeWrapper.attr('data-prototype').replace(new RegExp(name, 'g'), count),
        $proto = $(proto);

    $prototypeWrapper.append($proto);

    ReplaceSimple.init();
    Trigger.init();
});

$(document).on('click', '[data-prototype-delete]', function (e) {
    e.preventDefault();

    $(this).closest('[data-prototype-wrapper]').remove();
});

$(document).on('click', '[data-prototype-add]', function (e) {
    e.preventDefault();

    var $add = $(this),
        $prototypeWrapper = $($add.attr('data-prototype-add')),
        count = parseInt($prototypeWrapper.attr('data-prototype-count')) + 1 || $prototypeWrapper.children().length;

    $prototypeWrapper.attr('data-prototype-count', count);

    var name = $prototypeWrapper.attr('data-prototype-name') || '__name__',
        proto = $prototypeWrapper.attr('data-prototype').replace(new RegExp(name, 'g'), count),
        $proto = $(proto);

    $prototypeWrapper.append($proto);
});
